<template>
	<Layout header-class="header-left-align" nav-alignment="left" :topbar-style="2">
		<!-- Start Slider area -->
		<div class="slider-area slider-style-2 variation-2 height-450 bg_image"
				 :style="{'background-image': `url(${require(`@/assets/images/bwt/dscp-banner.jpg`)})`}">
			<div class="container">
				<div class="row">
					<div class="col-lg-8 col-xl-6">
						<div class="inner text-start" data-aos="fade-up" data-aos-delay="100">
							<h2 class="w-600 title text-left">数据安全管控平台</h2>
							<h4 class="text-left color-white">护航数据资产全生命周期安全</h4>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="rwt-advance-tab-area rn-section-gap sbg">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">数据安全管控平台</h2>
				<div style="margin-top: 48px; font-size: 18px">
					<p>聚焦于数据从生成至消亡的全生命周期管理，我们全面覆盖了开发、测试、运维、运营、访问、管理等多元化应用场景，通过整合数据采集安全、存储安全、开发测试数据使用安全、数据库运维安全、API接口防护、数据共享安全及数据外发安全等多个关键模块，精心打造了一个稳固的数据安全防护网。此体系旨在有效遏制数据违规行为，精准追溯非法访问轨迹，并即时告警任何异常操作。</p>
					<p>进一步地，我们的平台集成了数据分类分级管理、静态与动态数据脱敏技术、安全的数据共享机制以及全面的审计功能等多个子系统，为用户呈现出一个统一且标准化的操作界面。这一界面如同数据安全态势的全景窗口，让用户能够一目了然地掌握数据安全的整体状况，确保数据在各个环节中的安全、合规与高效利用。</p>
				</div>
			</div>
		</div>


		<div class="rwt-advance-tab-area rn-section-gap">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">核心功能</h2>
				<div style="margin-top: 48px; font-size: 18px">
					<div class="function-inner">
						<div class="edit-container">
							<ul class="clearfix">
								<li>
									<div class="block-box js-m delay1 animate">
										<div class="title">数据分类分级</div>
										<div class="cont">基于行业或者企业分类分级标准，通过数据资产自动扫描和数据自动识别，对企业数据资产进行分类分级，根据数据安全级别及数据访问用户权限配置。</div>
									</div>
								</li>
								<li>
									<div class="block-box js-m delay2 animate">
										<div class="title">数据静态脱敏</div>
										<div class="cont">对敏感数据进行处理，使其不可读、不可识别，保证数据安全性。同时保留原有数据唯一性、仿真性、关联性等特征，使其满足数据库的约束校验和数据规则校验。</div>
									</div>
								</li>
								<li>
									<div class="block-box js-m delay3 animate">
										<div class="title">数据动态脱敏</div>
										<div class="cont">在生产环境中，通过代理的方式对数据库实时访问请求进行解析，按照一定的规则和算法对敏感数据的查询和调用结果进行“实时”脱敏，保证数据安全。</div>
									</div>
								</li>
								<li>
									<div class="block-box js-m delay3 animate">
										<div class="title">数据库审计</div>
										<div class="cont">实时监控数据库运行情况，为安全事件溯源和追责提供有力的依据，提供符合《网络安全法》和《网络安全等级保护2.0制度》等法律法规及政策要求的分析报表。</div>
									</div>
								</li>
								<li>
									<div class="block-box js-m delay3 animate">
										<div class="title">数据安全共享</div>
										<div class="cont">基于数据资源目录对共享数据进行访问控制和操作权限管理，确保仅限经过授权的用户访问和操作数据，并对敏感数据进行脱敏、添加水印处理，让共享过程更安全。</div>
									</div>
								</li>
								<li>
									<div class="block-box js-m delay3 animate">
										<div class="title">数据防泄漏</div>
										<div class="cont">建立角色和权限系统，对用户的数据访问行为进行授权，根据用户的权限结合访问数据的安全级别配置安全访问策略，并设置数据访问的有效期。</div>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>

		<separator />

		<div class="rwt-advance-tab-area rn-section-gap">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">优势价值</h2>
				<div class="product" data-aos="fade-up" data-aos-delay="100">
					<div class="txt" >
						<div class="swiper-container">
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">一体化数据安全管控</div>
										<div class="t2">从数据采集安全、数据传输安全、数据共享安全、数据交换安全等多个维度对数据进行安全防护，实现数据安全统一管理、统一调度、统一服务、统一监控。</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">全生命周期安全护航</div>
										<div class="t2">帮助用户对数据资产进行梳理（资产统计、分类、聚类、分级、密级标识等）、安全管控（数据加密、权限管理，数据脱敏、应用准入、行为审计等）、态势感知（趋势分析、风险预警、精准溯源、风险人员画像等），通过定义数据访问权限模型，实现数据使用事前审批、事中监控、事后审计，在挖掘数据价值的同时保证企业数据安全。</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">多项数据安全技术加持</div>
										<div class="t2">融合机器学习、数据标识、大数据分析、关联分析、去标识化处理、访问控制等多项大数据技术和安全技术。</div>
									</div>
								</div>
							</div>
							<div class="swiper-pagination"></div>
						</div>
					</div>
					<div class="pic">
						<img src="@/assets/images/bwt/dscp1.png" style="border-radius: 12px;">
					</div>
				</div>
			</div>
		</div>

	</Layout>
</template>

<script>
import Layout from '@/components/common/Layout'
import Separator from '@/components/elements/separator/Separator'
import Swiper from "swiper";
import "swiper/css/swiper.css";
export default {
	name: 'About',
	components: {Separator, Layout},
	data() {
		return {

		}
	},
	mounted() {
		new Swiper(".swiper-container", {
			autoplay: true,
			delay: 2000,
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
				renderBullet: function (index, className) {
					return '<span class="' + className + '">' + (index + 1) + "</span>";
				},
			},
		});
	}
}
</script>
<style lang="scss" scoped>
.sbg {
	background-image: url("../../../assets/images/bwt/sbg.jpg");
}
.edit-container {
	position: relative;
	ul {
		margin: 0 -10px;
		display: block;
		li {
			display: inline-block;
			vertical-align: top;
			width: 33.333%;
			padding: 0 10px;
			text-align: left;
			margin-top: 15px;

			.block-box {
				padding: 34px 42px;
				position: relative;
				font-size: 16px;
				background-color: #f7f9fc;
				box-shadow: 0 10px 12px rgba(148, 160, 175, 0.33);
				border-radius: 8px;
				overflow: hidden;

				&:before {
					content: '';
					width: 100%;
					height: 6px;
					background: linear-gradient(to right, #c60c1a, #2270b2);
					position: absolute;
					left: 0;
					bottom: 0;
				}

				.title {
					font-size: 20px;
					font-weight: bold;
					height: 60px;
				}

				.cont {
					line-height: 1.8;
					height: 160px;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 6;
					-webkit-box-orient: vertical;
				}
			}
		}
	}
}

.product {
	margin-top: 72px;
	display: flex;
	.pic {
		width: 40%;
		img {
			width: 100%;
		}
	}
	.txt {
		width: 60%;
		.eee {
			width: 90%;
			text-align: left;
			.t1 {
				font-size: 24px;
				font-weight: 600;
				color: #000;
			}
			.t2 {
				margin-top: 12px;
				color: #000;
			}
		}
	}

}

.swiper-container {
	width: 100%;
	height: 100%;
	.swiper-wrapper {
		width: 100%;
	}
	.swiper-slide {
		width: 100%;
		text-align: center;
		font-size: 18px;
		background: #fff;
		display: flex;
		justify-content: center;
		align-items: flex-start;
		margin-top: 10%;
	}
	:deep(.swiper-pagination) {
		top: 70%;
	}

	:deep(.swiper-pagination-bullet) {
		width: 20px;
		height: 20px;
		text-align: center;
		line-height: 20px;
		font-size: 12px;
		color: #000;
		opacity: 1;
		background: rgba(0, 0, 0, 0.2);
	}

	:deep(.swiper-pagination-bullet-active){
		color: #fff;
		background: #007aff;
	}
}
</style>
